=<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">

                                <div class="dashboard-box margin-top-0">

                                    <div class="content with-padding padding-bottom-0" style="padding-top: 0px !important;">

                                        <div class="row">

                                            <div class="col-xl-10 col-md-9 col-lg-9">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o nome..." v-model="form.descricao">
                                                </div>
                                            </div>

                                            <div class="col-xl-12"></div>

                                            <div class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Select:</h5>
                                                    <small style="color: red; display: block; line-height: 120%; margin-bottom: 5px;">Atenção: O select deve retornar a coluna <b>CD_PESSOA_FISICA</b>.</small>
                                                    <textarea class="with-border" style="height: 300px; font-size: 14px; letter-spacing: 0px !important; font-weight: 400;" placeholder="" v-model="form.query"></textarea>
                                                </div>
                                            </div>

                                            <div class="col-xl-12 margin-bottom-30 margin-top-15">
                                                
                                                <button type="submit" class="button green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="las la-save"></i>
                                                    Salvar filtro
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarUsuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar,
        'AvatarCropper':            AvatarCropper
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "empresas": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "query":            "",
            }            
        }
    },
    watch: {
    },
    methods: {      
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/campanhas-filtros.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/campanhas-filtros.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarCampanhasFiltros") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },
    mounted: function() {
    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarCampanhasFiltros.vue